import $ from './el.JsModules.js';

elabs.MouseCursor = class {
  'use strict';

  // This was adapted from https://codepen.io/farisk/pen/bMgrxy

  init() {
    // This is generally complicated because some touch devices also have external mice e.g. some windows laptops, iPad pros

    // assume there is a mouse pointer initially, we are not sure at this moment
    this._initialise();

    // Detect if the user is primarily using a mouse device
    const detectMouse = (e) => {
      if (e.type === 'mousedown') {
        // We have confirmed it is a mouse (pointer) device
      } else if (e.type === 'touchstart') {
        // It is a touch device, do not need to have a mouse cursor
        this._deInitialise();
      }

      elabs.bodyElement.off('mousedown touchstart', detectMouse.bind(this));
    };

    elabs.bodyElement.on('mousedown touchstart', detectMouse.bind(this));
  }

  _initialise() {
    this.cursorElement = $('.el-cursor');

    elabs.documentElement.on('WINDOW_SCROLL_EVENT.EL_MOUSE_CURSOR', this.handleScrollEvent.bind(this));

    elabs.documentElement.on(
      'mouseenter.EL_MOUSE_CURSOR',
      'a, button, iframe, .el-cursor__magnifying-glass',
      this.cursorHover.bind(this),
    );

    elabs.documentElement.on(
      'mouseleave.EL_MOUSE_CURSOR',
      'a, button, iframe, .el-cursor__magnifying-glass',
      this.cursorBlur.bind(this),
    );
    elabs.documentElement.on('mousemove.EL_MOUSE_CURSOR', this.moveCursor.bind(this));
    elabs.documentElement.on('mousedown.EL_MOUSE_CURSOR', this.cursorDown.bind(this));
    elabs.documentElement.on('mouseup.EL_MOUSE_CURSOR', this.cursorUp.bind(this));

    elabs.documentElement.on('mouseout.EL_MOUSE_CURSOR', (e) => {
      const from = e.relatedTarget || e.toElement;
      if (!from || from.nodeName === 'HTML') {
        this.isCursorOnScreen = false;
        this.cursorElement.addClass('el-cursor--hidden');
      }
    });

    this.cursorElement.show();
  }

  _deInitialise() {
    elabs.documentElement.off('.EL_MOUSE_CURSOR');
    this.cursorElement.hide();
  }

  handleScrollEvent() {
    // Clear our timeout throughout the scroll
    window.clearTimeout(this.isScrollingTimer);

    if (!this.isScrollingTimer) {
      this.cursorElement.addClass('el-cursor--mouse-down');
    }

    // Set a timeout to run after scrolling ends
    this.isScrollingTimer = setTimeout(() => {
      this.cursorElement.removeClass('el-cursor--mouse-down');
      this.isScrollingTimer = false;
    }, 300);
  }

  moveCursor(e) {
    if (!this.isCursorOnScreen) {
      this.isCursorOnScreen = true;
      this.cursorElement.removeClass('el-cursor--hidden');
    }

    this.cursorElement.css({ top: e.clientY, left: e.clientX });

    /*this.cursorElement.addClass('el-cursor--is-moving');
        clearTimeout(movingTimer);

        movingTimer = setTimeout(() => {
            this.cursorElement.removeClass('el-cursor--is-moving');
        }, 300);*/
  }

  cursorHover(evt) {
    if (evt.target.classList.contains('el-cursor__magnifying-glass')) {
      this.cursorElement.addClass('el-cursor--magnifying-glass');
    } else if (evt.target.classList.contains('el-cursor__nav-left')) {
      this.cursorElement.addClass('el-cursor--arrow is-left');
    } else if (evt.target.classList.contains('el-cursor__nav-right')) {
      this.cursorElement.addClass('el-cursor--arrow is-right');
    } else if (evt.target.classList.contains('el-cursor__hide-cursor') || evt.target.nodeName === 'IFRAME') {
      this.cursorElement.addClass('el-cursor--hidden');
    } else {
      this.cursorElement.addClass('el-cursor--is-hovering');
    }
  }

  cursorBlur() {
    this.cursorElement.removeClass(
      'el-cursor--is-hovering el-cursor--magnifying-glass el-cursor--arrow is-right is-left el-cursor--hidden',
    );
  }

  cursorDown() {
    this.cursorElement.addClass('el-cursor--mouse-down');
  }

  cursorUp() {
    this.cursorElement.removeClass('el-cursor--mouse-down');
  }
};

elabs.MouseCursor = new elabs.MouseCursor();
